module.exports = __webpack_public_path__ + "static/media/NOTTINGHAM_APP_LOGO.8b800872.png";